import React from 'react';
import PropTypes from 'prop-types';
import {connectIntegration, disconnectIntegration} from "../../redux/actions/integrationsConnectionActions";
import rocketMatterIcon from "./icons/rocketmatter.png";
import RocketMatterAuthenticator from "./RocketMatterAuthenticator";

export default class RocketMatterSwitch extends React.Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired
  };

  state = {
    loading: false,
  };

  onClick = () => {
    const {connectionId} = this.props;

    if (connectionId === null) {
      this.setState({loading: true});
      // call Authenticator
      RocketMatterAuthenticator()
        .login({ state: { redirect_host: window.location.host } })
        .then(
          ({ authResponse }) => {
            this.props.dispatch(connectIntegration('files', 'rocketmatter', authResponse));
            this.setState({ loading: false });
          },
          (res) => {
            const { code, message } = res.error;
            this.setState({ loading: false });
            notify.error(`Error connecting to RocketMatter: [${code}] ${message || ''}`);
          }
        );
    }
    else {
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  render() {
    const {connectionId, agreedToPricing} = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2">
        <img className="kloudless-connection-icon"
          src={rocketMatterIcon}
             alt="Rocket Matter Logo"
        />

        <div className={iconCls} onClick={this.onClick}>
          {this.state.loading &&
            <i className={"fa fa-circle-o-notch fa-spin"}
              style={{marginTop: '10px', marginLeft: '11px', fontSize: '11px'}}
            />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/RocketMatterSwitch.jsx